import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/system';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(
    radioAnatomy.keys,
);

const baseStyle = definePartsStyle({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        minHeight: 5,
    },
    label: { marginLeft: 2, width: 'full' },
    control: {
        transitionProperty: 'none',
        width: 4,
        height: 4,
        marginTop: 1,
        border: '1px solid',
        borderColor: 'slt-pepper.1000',
        _checked: {
            boxShadow: '0 0 0 2px white inset',
            backgroundColor: 'slt-pepper.1000',
            borderColor: 'slt-pepper.1000',
            _disabled: {
                backgroundColor: 'slt-pepper.1000',
                borderColor: 'slt-pepper.1000',
                _before: {
                    display: 'none',
                },
            },
            _hover: null,
            _before: null,
        },
        _focus: null,
        _focusVisible: null,
        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed',
            backgroundColor: 'white',
            borderColor: 'slt-pepper.1000',
            _before: {
                content: '""',
                position: 'absolute',
                top: '11px',
                transform: 'rotate(45deg)',
                borderColor: 'transparent',
                borderTop: '1px solid',
                borderTopColor: 'slt-pepper.1000',
                width: 'calc(hypot(16px,18px))',
            },
        },
        _before: null,
    },
});

// When we fully migrate Checkout text styles, we can change the base size to be the base style.
export const Radio = defineMultiStyleConfig({
    baseStyle,
    sizes: {
        base: {
            label: {
                textStyle: 'body-base',
            },
        },
    },
});
